/**
 * @description
 * Objeto dbattrs
 */

import { Dbmodels } from "./dbmodels.model";

export class Dbattrs {
    public id:number = null;
    public code:string = "";
    public description:string;
    public adapterstr:string;
    public usernamestr:string;
    public passwordstr:string;
    public dbattr1key:string;
    public dbattr1value:string;
    public dbattr2key:string;
    public dbattr2value:string;
    public dbattr3key:string;
    public dbattr3value:string;
    public dbattr4key:string;
    public dbattr4value:string;
    public dbattr5key:string;
    public dbattr5value:string;
    public modelo: number = 0;
    public dbmodels: Dbmodels[] = [];
    public info: boolean = true;
  
    constructor() {}
  
}